module.exports = __webpack_public_path__ + "static/media/becomeFlexHost.fb3fff0b.jpg";